module.exports = __webpack_public_path__ + "img/9.60801b37.jpg";